import SpecialityIcon from "@mui/icons-material/Vaccines";
import ListSpecialities from "./List";
import { SPECIALITIES, AdministrationServicePath } from "utils/constants";
import EditSpecialities from "./Edit";
import CreateSpecialities from "./Create";
import ShowSpecialities from "./Show";
import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  icon: <SpecialityIcon />,
  name: AdministrationServicePath + SPECIALITIES,
  title: "Специалности",
  list: <ListSpecialities />,
  create: <CreateSpecialities />,
  createPermission: permissions.canCreateSpecialities,
  edit: <EditSpecialities />,
  editPermission: permissions.canUpdateSpecialities,
  show: <ShowSpecialities />,
  showPermission: permissions.canPreviewSpecialities,
  permission: permissions.canPreviewSpecialities,
};
